import React, {FC} from "react";
import VidaSection from "../../../../components/@vida/vida-section";
import Divider from "../divider";
import Spacer from "../spacer";
import Note from "../note";

const ConnectingSpaOrCmaPlatformVehicles: FC = () => {
  return <div>
    <VidaSection title="" id="connecting-spa-or-cma-platform-vehicles">
      <Divider/>
      <h1>Connecting SPA or CMA Platform Vehicles</h1>

      {/* Car Connection SPA CMA Platform */}
      <Spacer/>
      <VidaSection title="Car Connection SPA CMA Platform" id="car-connection-spa-cma-platform">
        <p><strong>Car Connection SPA CMA Platform</strong></p>
        <p>SPA and CMA cars connect using the VOE Adapter.</p>
        <p>VOE Part number 9513108<br/>Ethernet RJ45 cable 9513095</p>
        <p>Part number 9513108 VOE adapter - one end plugs into the OBDII connector in the car - the other end plugs
          into the laptop Ethernet port. If that port is being used for an internet connection, then a USB to Ethernet
          adapter is needed.</p>
      </VidaSection>

      {/* Connecting a vehicle (VDS) SPA and CMA platform */}
      <Spacer/>
      <VidaSection title="Connecting a vehicle (VDS) SPA and CMA platform"
                   id="connecting-a-vehicle-vds-spa-and-cma-platform">
        <p><strong>Connecting a vehicle to VIDA via cable (VDS)</strong></p>
        <p>These procedures describe how to connect a VDS protocol-based vehicle to VIDA and perform a readout.</p>
        <p>Connecting the vehicle peer-to-peer via cable is technically a basic communication level and may thus need to
          be employed for a few special repair methods and fault tracing situations. The specific methods will state
          when this is necessary.</p>
        <p><strong>How to connect the cable between the vehicle and VIDA</strong></p>
        <p>Use the special OBD to Ethernet (VOE) adapter.</p><br/><br/>
        <img
          src="https://cdn.volvotechinfo.com/vida-basic-training/Connecting%20SPA%20or%20CMA%20Platform%20Vehicles/Connecting%20a%20vehicle%20(VDS)%20SPA%20and%20CMA%20platform_image1.jpg"
          alt="Connecting a vehicle (VDS) SPA and CMA platform_image1"/>
        <p>Fig. 299: VOE adapter</p>
        <Spacer/>
        <ol>
          <li>Connect the Ethernet cable to the adapter.<br/><br/><img
            src="https://cdn.volvotechinfo.com/vida-basic-training/Connecting%20SPA%20or%20CMA%20Platform%20Vehicles/Connecting%20a%20vehicle%20(VDS)%20SPA%20and%20CMA%20platform_image2.jpg"
            alt="Connecting a vehicle (VDS) SPA and CMA platform_image2"/><br/>Fig. 300: Ethernet cable<Spacer/></li>
          <li>Insert the VOE adapter into the OBD connector of the vehicle.</li>
          <li>Insert the other end of the Ethernet cable directly into the VIDA workstation.<br/><br/><img
            src="https://cdn.volvotechinfo.com/vida-basic-training/Connecting%20SPA%20or%20CMA%20Platform%20Vehicles/Connecting%20a%20vehicle%20(VDS)%20SPA%20and%20CMA%20platform_image3.jpg"
            alt="Connecting a vehicle (VDS) SPA and CMA platform_image3"/><br/>Fig. 301: Connecting Ethernet cable to
            computer<Spacer/>If no Ethernet socket is available, you can use a USB Ethernet adapter.<br/><br/><img
              src="https://cdn.volvotechinfo.com/vida-basic-training/Connecting%20SPA%20or%20CMA%20Platform%20Vehicles/Connecting%20a%20vehicle%20(VDS)%20SPA%20and%20CMA%20platform_image4.jpg"
              alt="Connecting a vehicle (VDS) SPA and CMA platform_image4"/><br/>Fig. 302: USB Ethernet adapter<Spacer/>
          </li>
          <li>Configure the USB Ethernet adapter to <strong>automatic</strong> IP. Static IP retrieval
            does <strong>not</strong> work.<br/><br/>A BIOS setting {'"'}Wireless Radio Control{'"'} must allow Wireless
            LAN at the same time as an Ethernet connection is running. If the computer{"'"}s BIOS setting does not allow
            for this then VDS protocol-based vehicles will not appear in the Connected Vehicles list (assuming the
            connection to internet is done over WLAN).<br/><br/>{"->"} When the Vehicle Connectivity Module (VCM) is
            announcing itself, the LEDs at the LAN port of the computer or USB Ethernet adapter are lit or
            flashing.<br/><br/><img
              src="https://cdn.volvotechinfo.com/vida-basic-training/Connecting%20SPA%20or%20CMA%20Platform%20Vehicles/Connecting%20a%20vehicle%20(VDS)%20SPA%20and%20CMA%20platform_image5.jpg"
              alt="Connecting a vehicle (VDS) SPA and CMA platform_image5"/><br/>Fig. 303: LAN port<Spacer/></li>
        </ol>
        <p><strong>How to connect the vehicle in VIDA and perform a readout</strong></p>
        <ol>
          <li>Under the <strong>Home</strong> tab, select the <strong>Connected Vehicles</strong> tab.</li>
          <li>Click the <strong>Connect</strong> button for the vehicle you want to connect.<br/>{"->"} If a previous
            readout for the vehicle is found, the following pop-up is displayed:<br/><br/><img
              src="https://cdn.volvotechinfo.com/vida-basic-training/Connecting%20SPA%20or%20CMA%20Platform%20Vehicles/Connecting%20a%20vehicle%20(VDS)%20SPA%20and%20CMA%20platform_image6.jpg"
              alt="Connecting a vehicle (VDS) SPA and CMA platform_image6"/><br/>Fig. 304: Previous readout was
            found<Spacer/></li>
          <li>The <strong>Previous readout found</strong> pop-up has the
            options <strong>New</strong> , <strong>Existing</strong> and <strong>Disconnect</strong>. Click the desired
            option.<br/>{"->"} The vehicle is connected and assigned its own tab.
          </li>
        </ol>
        <Note
          body={<><p>By default, VIDA selects Existing when the dialog{"'"}s time has passed. Under Personalize Settings
            in VIDA, it is possible to change the default mode to New when connecting to a vehicle.</p><p>For more
            information about readout settings, see Personalize Settings.</p></>}/><br/>
        <Note
          body={<p>Click Locate the vehicle to identify a vehicle by running a script that will blink the headlights.
            This will be useful once vehicles are connected over LAN and WLAN. If the blinking vehicle is not the
            expected one, you can choose to disconnect the vehicle by clicking the Disconnect button which will shut
            down the vehicle tab.</p>}/>
      </VidaSection>
    </VidaSection>
    <style jsx>{`
      img {
        width: 75%;
      }
    `}</style>
  </div>
}

export default ConnectingSpaOrCmaPlatformVehicles;
